export const load = () => ({
	title: 'What is STC Rating?',
	showTitle: true,
});
